// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3JDSR","loaderOuter":"PageOverlayLoader_loaderOuter__1Q7eh"};